/* eslint-env browser */
import { parse, serialize } from 'cookie';

// Adapted from https://www.quirksmode.org/js/cookies.html

export function getCookie(name: string) {
  const cookies = parse(document.cookie);
  return cookies[name];
}

/**
 * Sets a cookie with the given name, value, and optional expiration date.
 * @param name - The name of the cookie.
 * @param value - The value of the cookie.
 * @param days - The number of days until the cookie expires. Use this OR set an expiration date directly in options.expires.
 * @param options - Additional options for the cookie.
 * @param options.expires - The expiration date of the cookie. Use this only if you need a specific expiration, like needing a cookie to expire at the same time as the token it's storing
 */
export function setCookie(
  name: string,
  value: string,
  days?: number,
  options?: { expires?: Date }
) {
  let expires;

  if (options?.expires) {
    expires = new Date(options.expires);
  }

  if (days) {
    expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  }

  document.cookie = serialize(name, value, { expires, path: '/', secure: true });
}

export function unsetCookie(name: string) {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
}
